export const ZH_CN = {

  'header': '段落格式',
  'normal': '正文',
  'h1': '标题1',
  'h2': '标题2',
  'h3': '标题3',
  'h4': '标题4',
  'h5': '标题5',
  'h6': '标题6',

  'lineheight': '行距',
  'songti': '宋体',
  'yahei': '微软雅黑',
  'kaiti': '楷体',
  'heiti': '黑体',
  'lishu': '隶书',

  'left': '左对齐',
  'center': '居中对齐',
  'right': '右对齐',

  'codeblock': '代码块',
  'globallink': '全局链接',

  'exit-fullscreen': '退出全屏',
  'help': '帮助',
  'more': '更多',

  'help-format': '格式',
  'help-insert': '插入',
  'help-operation': '操作',
  'mention': '提及某人',
  'quick-menu': '快捷菜单',
  'toggle-help-panel': '打开/关闭帮助面板',
  'scroll-table': '水平滚动表格',
  'mouse-wheel': '鼠标滚轮',
  'save': '保存',

  'copy-cells': '复制',
  'copy-table': '复制表格',
  'cut-cells': '剪切',
  'empty-cells': '清空内容',

  'insert-row-up': '上插入行',
  'insert-row-down': '下插入行',
  'insert-column-left': '左插入列',
  'insert-column-right': '右插入列',

  'merge-cells': '合并单元格',
  'unmerge-cells': '拆分单元格',

  'delete-row': '删除当前行',
  'delete-column': '删除当前列',
  'delete-table': '删除表格',

  'default-link-text': '链接',
  'basicblock': '卡片',
  'linkplaceholder': '请输入链接地址，按回车键确认',
  'counter-template': '{{count}}/{{totalCount}}',
  'char': '字符',
  'word': '单词',
  'counter-limit-tips': '{{countUnit}}数超出最大允许值',
  'ie-msg': '为了有更好的体验，推荐使用最新版Chrome浏览器。',

  'loading': '正在加载中...',
  'pasting': '您粘贴的内容较多，正在努力加载中，请耐心等待...',
  'img-error': '图片复制出错',
  'img-error-info':
    '此图片不支持复制，请将原图下载至本地后点击工具栏【插入图片】，重新上传。',

  'last-modified': '最后修改时间：',
  'screenshot': '截图',
  'uploading': '上传中...',
  'sub-title-bg-color': '背景颜色',

  // blot tip name
  'emoji': '表情',
  'fullscreen': '全屏',
  'blockquote': '引用',
  'undo': '撤销',
  'redo': '重做',
  'clean': '清除格式',
  'bold': '粗体',
  'italic': '斜体',
  'underline': '下划线',
  'strike': '删除线',
  'image': '图片',
  'file': '文件',
  'table': '表格',
  'link': '超链接',
  'divider': '分割线',
  'code': '行内代码',
  'better-table': '表格',
  'code-block': '代码块',
  'formula': '公式',
  'format-painter': '格式刷',
  'video': '视频',
  'color': '字体颜色',
  'background': '背景色',
  'font': '字体',
  'size': '字号',
  'list-ordered': '有序列表',
  'list-bullet': '无序列表',
  'list-check': '任务列表',
  'align-left': '左对齐',
  'align-center': '居中对齐',
  'align-right': '右对齐',
  'align-justify': '两端对齐',
  'direction-ltr': '文本方向左到右',
  'direction-rtl': '文本方向右到左',
  'indent--1': '减少缩进',
  'indent-+1': '增加缩进',
  'script-super': '上标',
  'script-sub': '下标',
  'header-normal': '正文',
  'header-1': '标题1',
  'header-2': '标题2',
  'header-3': '标题3',
  'header-4': '标题4',
  'header-5': '标题5',
  'header-6': '标题6',
  'header-list': '标题列表',
}
